import React from "react";

import {
  Globe,
  Mail,
  Phone,
  CircleUserRound,
  BadgeDollarSign,
} from "lucide-react";

import "./Footer.css";

const Footer = () => {

  return (
    <footer className="modern-footer">

      <div className="modern-footer-top">

        {/* BRAND */}
        <div className="modern-footer-brand">

<h2>
  Built Around Convenience.
</h2>

<p>
  Reliable financial services,
  bill payments, investments, money remittance,
  insurance and business
  solutions across Guyana.
</p>

        </div>

        {/* QUICK LINKS */}
        <div className="modern-footer-links">

          <h3>Quick Links</h3>

          <a href="/">Home</a>

          <a href="/services">
            Services
          </a>

          <a href="/about">
            About
          </a>

          <a href="/contact">
            Contact
          </a>

        </div>

        {/* CONTACT */}
        <div className="modern-footer-contact">

          <h3>Contact</h3>

          <div className="footer-contact-item">
            <Phone size={18} />
            <span>
              +592-662-7987
            </span>
          </div>

          <div className="footer-contact-item">
            <Mail size={18} />
            <span>
              rcs@rcsgy.com
            </span>
          </div>

          <div className="footer-contact-item">
            <Globe size={18} />
            <span>
              www.rcsgy.com
            </span>
          </div>

        </div>

      </div>

      {/* SOCIALS */}
<div className="modern-footer-socials">

  <a href="/">
    <CircleUserRound size={20} />
  </a>

  <a href="/">
    <BadgeDollarSign size={20} />
  </a>

</div>

      {/* BOTTOM */}
      <div className="modern-footer-bottom">

        © {new Date().getFullYear()}
        {" "}
        RCS Management.
        All intellectual rights reserved.

        <br />

        All trademarks, registered names,
        slogans and logos used on this site
        are copyright to their respective
        companies.

      </div>

    </footer>
  );
};

export default Footer;